import React, { useState } from 'react';
import { useQuery, useMutation } from 'react-query';
import { endpoints, fetcher } from 'services';
import { INIT_PAGESIZE } from 'commons/constants';
import { useLocation } from 'react-router-dom';
import qs from 'query-string';

const useMyBill = (page: string, userid: string) => {
  /* ======================================================
   * state
   * ====================================================== */
  const [billList, setBillList] = useState<BillListDto[]>();
  const [searchResult, setSearchResult] = useState({ pageNo: 0, pageSize: INIT_PAGESIZE, totalCount: 0 });

  /* ======================================================
   * hooks
   * ====================================================== */
  const location = useLocation();
  const searchParams = qs.parse(location.search);
  const { isLoading, refetch } = useQuery(
    [endpoints.mypage.bill, [location.search, userid, page]],
    () =>
      fetcher.mypage.postMyBillList1({
        pageNo: Number(searchParams.pageNo) || 1,
        pageSize: Number(searchParams.pageSize) || INIT_PAGESIZE,
        pm: String(userid),  
        group: String(page),  
      }),
    {
      enabled: (page === 'bill1' || page === 'bill2'), 
      onSuccess: (res: CommonSearchListResDto) => {
        switch (res.code) {
          case 200:
            setBillList(res.result?.list);
            setSearchResult({
              pageNo: res.result?.pageNo || 1,
              pageSize: res.result?.pageSize || INIT_PAGESIZE,
              totalCount: res.result?.totalCount || 0,
            });
            break;
          case 400:
          default:
            break;
        }
      },
    },
  );

  const { mutate: billHidden, isSuccess: hiddenSuccess } = useMutation(
    [endpoints.mypage.billhidden],
    fetcher.mypage.postMyBillHidden,
    {
      onSuccess: (res) => {
        switch (res.code) {
          case 200:
            break;
          default:
            break;
        }
      },
    },
  )  

  return { billList, searchResult, refetch, billHidden, hiddenSuccess };
};

export default useMyBill;
